import PropTypes from 'prop-types';
import validateEmail from '@utils/validators';
import { K12_LANDING_BOOKING_ACTIVITY_STARTED } from '@constants/segment';
import { segment } from '@actions/analytics';
import { getClassBookedInfo } from '@actions/cbseClass';
import { useDispatch } from 'react-redux';
import InputAdornment from '@material-ui/core/InputAdornment';
import CountryMenu from '@cont/Login/CountryMenu';
import {
  FormContainer,
  StyledTextField,
  ChooseClass,
  Classes,
  Class,
  BookClassButon,
  AcceptTerms,
  TermsContent,
  TermsBox,
  TermsLink,
  InputField
} from './styles';

const Form = ({
  updateForm,
  state,
  dispatch,
  heroForm,
  country,
  countries,
  changeCountry,
  getGoalName
}) => {
  const reduxDispatch = useDispatch();
  const {
    fields: formFields,
    classes,
    termsText,
    btnText,
    classTitle
  } = heroForm;
  const { name, email, phoneNumber, goal_uid, selectedClass, errors } = state;
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: 'SET_ERRORS', payload: {} });
    const formErrors = {};
    if (!name.trim()) formErrors.name = 'This field cannot be empty';
    if (!phoneNumber) formErrors.phoneNumber = 'This field cannot be empty';
    if (email && !validateEmail(email)) formErrors.email = 'Invalid Email';
    if (!email) formErrors.email = 'This field cannot be empty';
    if (!goal_uid) formErrors.selectedClass = 'This field cannot be empty';
    if (Object.keys(formErrors).length > 0) {
      dispatch({ type: 'SET_ERRORS', payload: formErrors });
      return;
    }
    document.getElementById('lead-gen')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    const goalName = getGoalName(goal_uid);
    const data = {
      name,
      email,
      phoneNumber,
      goal_uid,
      class: selectedClass,
      goal_name: goalName,
      activity_type: btnText
    };
    segment.track(K12_LANDING_BOOKING_ACTIVITY_STARTED, data);
    reduxDispatch(getClassBookedInfo(goal_uid)).then(({ result }) => {
      let formType;
      if (result?.uid) {
        formType = 'CLASS_BOOKED';
        dispatch({ type: 'TOGGLE_BOOKED_CLASS', payload: true });
      }
      updateForm(formType);
    });
  };
  const handleChange = (e, value) => {
    e.preventDefault();
    dispatch({
      type: 'SET_ERRORS',
      payload: { ...errors, [e.target.dataset.key]: '' }
    });
    const PAYLOAD =
      e.target.name === 'SET_GOAL_UID' ? value : e.target.value || value;
    dispatch({ type: e.target.name, payload: PAYLOAD });
  };
  return (
    <FormContainer onSubmit={handleSubmit}>
      <StyledTextField
        placeholder={formFields.name}
        value={name}
        helperText={errors.name}
        error={!!errors.name}
        name="SET_NAME"
        type="text"
        autoFocus
        onChange={handleChange}
        autoComplete="off"
        inputProps={{ 'data-key': 'name' }}
      />
      <InputField
        fullWidth
        startAdornment={
          <InputAdornment position="start">
            <CountryMenu
              changeCountry={changeCountry}
              country={country}
              countries={countries}
            />
          </InputAdornment>
        }
        placeholder={formFields.phoneNumber}
        onChange={handleChange}
        value={phoneNumber}
        inputProps={{
          maxLength: 10,
          inputMode: 'numeric',
          pattern: '[0-9]*',
          'data-key': 'phoneNumber'
        }}
        name="SET_PHONE_NUMBER"
        type="tel"
        helperText={errors.phoneNumber}
        error={!!errors.phoneNumber}
        autoComplete="off"
      />
      <StyledTextField
        placeholder={formFields.email}
        value={email}
        name="SET_EMAIL"
        helperText={errors.email}
        error={!!errors.email}
        onChange={handleChange}
        autoComplete="off"
        inputProps={{ 'data-key': 'email' }}
      />
      <ChooseClass>{classTitle}</ChooseClass>
      <Classes>
        {classes.map((cls) => (
          <Class
            key={cls.goal_uid}
            type="button"
            name="SET_GOAL_UID"
            onClick={(e) => handleChange(e, cls)}
            $selectedClass={goal_uid === cls.goal_uid}
          >
            {cls.name}
          </Class>
        ))}
      </Classes>
      <BookClassButon type="submit" height="sm">
        {btnText}
      </BookClassButon>
      <AcceptTerms>
        <TermsBox checked color="default" size="small" />
        <TermsContent>
          <span>{termsText}</span>
          <TermsLink target="_blank" href="/terms">
            <strong> Unacademy’s terms</strong>
          </TermsLink>
        </TermsContent>
      </AcceptTerms>
    </FormContainer>
  );
};

Form.propTypes = {
  updateForm: PropTypes.func.isRequired,
  state: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  heroForm: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Form;
